interface ComputerWithLight2SVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithLight2SVG = ({
  color,
  style,
}: ComputerWithLight2SVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="50"
    viewBox="0 0 45 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1753_36723)">
      <path
        d="M25.4937 29.1919V29.7135C25.4937 31.4965 26.9353 32.9381 28.7183 32.9381H30.103C31.886 32.9381 33.3276 31.4965 33.3276 29.7135V29.1919L33.2802 27.4184V27.3899C33.2802 26.2803 33.7069 25.2181 34.4941 24.4404C35.8124 23.1316 36.628 21.3201 36.628 19.319C36.628 15.165 33.1189 11.8266 28.8985 12.1206C25.3799 12.3672 22.5063 15.1934 22.2123 18.712C22.0321 20.9218 22.8477 22.9514 24.2608 24.3835C25.0575 25.1896 25.5412 26.2613 25.5412 27.3994V27.4279H29.4107"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5898 33.0046V33.64C27.5898 34.6453 28.4055 35.461 29.4108 35.461C30.4161 35.461 31.2317 34.6453 31.2317 33.64V32.9951"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4023 10.4032V8.75293"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.3581 11.0105L25.7891 9.45508"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.7045 12.6224L22.6328 11.3516"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7485 15.0409L20.3164 14.2158"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.457 11.0105L33.0261 9.45508"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.1094 12.6224L36.1811 11.3516"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.0625 15.0409L38.4946 14.2158"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.3618 33.4407L20.2841 45.1346C19.4021 45.6467 18.3019 45.6562 17.4199 45.1346L5.06214 38.0026C4.23703 37.5284 3.73438 36.6463 3.73438 35.6979V18.7973C3.73438 17.6592 4.34136 16.6065 5.31821 16.0375L26.297 3.8125"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.1835 26.3001L43.3819 30.4256C44.0553 30.8145 44.4726 31.5353 44.4726 32.3225V33.7545C44.4726 34.5322 44.0553 35.253 43.3914 35.6419L20.2882 49.0998C19.4062 49.6119 18.325 49.6214 17.4335 49.1092L1.87018 40.2322C1.03558 39.758 0.523438 38.8759 0.523438 37.9181V17.0057C0.523438 15.8676 1.13042 14.8149 2.10728 14.2458L25.2579 0.778448C25.808 0.45599 26.4908 0.45599 27.0409 0.75948L28.1126 1.35698C28.8713 1.78376 29.3455 2.58042 29.3455 3.45296V5.9852"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32422 34.56L21.7442 26.7451"
        stroke={color}
        strokeWidth="1.06222"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1753_36723">
        <rect width="45.0019" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithLight2SVG;
